import { createReducer } from '@mews/framework';
import { ApplicationState, ResourceCategoryAvailability } from '@mews-commander/types';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import {
    AVAILABILITY_BLOCKS_INIT_STARTED,
    AVAILABILITY_BLOCKS_INIT_SUCCEEDED,
    AVAILABILITY_BLOCKS_INIT_FAILED,
    SERVICE_AVAILABILITIES_FETCH_SUCCEEDED,
} from '../actionTypes';
import { InitState } from '../types';

const INITIAL_STATE: InitState = {
    availabilities: [],
    ...META_STATE_SUCCEEDED,
};

export default createReducer(INITIAL_STATE, {
    [SERVICE_AVAILABILITIES_FETCH_SUCCEEDED]: (
        state: ApplicationState,
        availabilities: Array<ResourceCategoryAvailability>
    ) => ({
        ...state,
        availabilities,
    }),
    ...createEntityAsyncMetaHandlers({
        STARTED: AVAILABILITY_BLOCKS_INIT_STARTED,
        SUCCEEDED: AVAILABILITY_BLOCKS_INIT_SUCCEEDED,
        FAILED: AVAILABILITY_BLOCKS_INIT_FAILED,
    }),
});
